import { t } from '@/lib/i18n'

const state = {
  type: null,
  message: null,
  title: '',
  isShow: false
}

// TODO: Enfileirar mensagens quando state.isShow for true
// TODO: Log erro

const actions = {
  success ({ state, commit }, message) {
    if (!state.isShow) {
      commit('success', message.message)
    }
  },

  error ({ state, commit }, error) {
    if (!state.isShow) {
      commit('error', t(`${error.message}`))
    }
  },

  clean ({ commit }) {
    commit('clean')
  }
}

const mutations = {
  success (state, message) {
    state.isShow = true
    state.type = 'success'
    state.title = 'Sucesso'
    state.message = message
  },

  error (state, message) {
    state.isShow = true
    state.type = 'error'
    state.title = 'Erro'
    state.message = message
  },

  clean (state) {
    state.isShow = false
    state.type = null
    state.title = ''
    state.message = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
